import React, { useState } from 'react'
import styled from 'styled-components'
import { colours } from '@qflow/theme'

import { useCountryDrivenValues } from 'portal/lib/hooks'
import { RecordHistoryFieldDetails } from './RecordHistoryFieldDetails'

export function RecordHistoryFieldSection({
  section,
  ModuleSection,
  historyObject,
  index
}) {
  const [showCloseAll, setShowCloseAll] = useState(false)
  const { text: overwriteText } = useCountryDrivenValues()

  const openAllDetails = (event: any) => {
    const groupTitleElement = event.target.parentElement
    const fieldGroup = groupTitleElement.nextElementSibling
    fieldGroup
      .querySelectorAll('details')
      .forEach((detail: HTMLDetailsElement) => {
        detail.open = true
      })
    setShowCloseAll(true)
  }

  const closeAllDetails = (event: any) => {
    const groupTitleElement = event.target.parentElement
    const fieldGroup = groupTitleElement.nextElementSibling
    fieldGroup
      .querySelectorAll('details')
      .forEach((detail: HTMLDetailsElement) => {
        detail.open = false
      })
    setShowCloseAll(false)
  }

  return (
    <>
      <SectionTitle style={index === 0 ? { marginTop: 0 } : {}}>
        <div>{overwriteText[section.toLowerCase()] || section}</div>
        {showCloseAll ? (
          <OpenCloseAll onClick={closeAllDetails}>Close all</OpenCloseAll>
        ) : (
          <OpenCloseAll onClick={openAllDetails}>Open all</OpenCloseAll>
        )}
      </SectionTitle>
      <FieldWrapper>
        {ModuleSection.map(key => {
          return (
            <RecordHistoryFieldDetails
              fieldName={key}
              historyObject={historyObject[key]}
              key={key}
            />
          )
        })}
      </FieldWrapper>
    </>
  )
}

const SectionTitle = styled.div`
  font-family: 'Jakarta Sans', 'Inter', sans-serif !important;
  font-size: 15px;
  font-weight: 700;
  color: ${colours.CORE_NAVY};
  margin: 1.25rem 0 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const OpenCloseAll = styled.div`
  font-size: 12px;
  color: ${colours.LIGHT_NAVY};
  cursor: pointer;
  font-weight: 400;
  flex-shrink: 0;
`
const FieldWrapper = styled.div`
  padding: 0;
  border: 1px solid ${colours.CLOUD_GREY};
  border-radius: 10px;

  & > details:last-of-type {
    border-bottom: none;
  }
`
